import { z } from "zod";

export const EmpreendimentoSchema = z.object({
    idEmpreendimento: z.coerce.number(),
    idCentroCusto: z.coerce.number({ required_error: 'O Campo deve ser selecionado!!', invalid_type_error: 'O Campo deve ser selecionado!!' })
        .gt(0, { message: "Deve ser selecionado um centro de custo para o cadastro do empreendimento!" }),
    tipo: z.coerce.number().default(0),
    descricao: z.string({ required_error: "O campo deve ser preenchido!" }),
    apresentacao: z.string().nullable().default(null),
    blocosQuantidade: z.coerce.number()
        .default(1),
    andaresQuantidade: z.coerce.number()
        .default(0),
    apartamentosQuantidade: z.coerce.number()
        .gt(0, { message: "A quantidade de apartamentos deve ser maior que zero." }),


});

export type EmpreendimentoForm = z.infer<typeof EmpreendimentoSchema>;






